import { useCallback, useEffect, useMemo, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { useTranslations } from 'next-intl'
import { GetStaticProps } from 'next'
import { FabricImage, StaticCanvas, filters } from 'fabric'

import Header from '../components/layouts/header'
import Upload from '../svg/upload'
import { Seo } from '@/components/seo'

function ImageGrayscale() {
  const [file, setFile] = useState<File | null>(null)
  const [targetImage, setTargetImage] = useState<string>('')
  const t = useTranslations('ImageGrayscale')

  const onDrop = useCallback((acceptedFiles: File[]) => {
    setFile(acceptedFiles[0])
  }, [])

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: false,
    accept: {'image/*': []}
  })

  const originImage = useMemo(() => {
    if (file) {
      return URL.createObjectURL(file)
    }
  }, [file])

  useEffect(() => {
    if (originImage) {
      FabricImage.fromURL(originImage).then((img: FabricImage) => {
        img.filters = [new filters.Grayscale()]
        img.applyFilters()
        
        
        setTargetImage(img.toDataURL())
      })
    }
  }, [originImage])

  return (
    <div className="min-h-screen">
      <Seo
        title={t('pageTitle')}
        description={t('pageDescription')}
        thumbnail="https://devtool.tech/thumbnail/image-grayscale.png"
        path="/image-grayscale"
      />
      <Header title={t('headerTitle')} />
      <div className="container mx-auto px-4 py-8">
      <div {...getRootProps()} className="grid p-4 mb-4 app-upload place-items-center">
        <input {...getInputProps()} />
        <Upload className="text-orange-500 fill-current" />
        <p className="my-1 italic text-gray-600">{t('imageGrayscaleGenerator')}</p>
        <p className="text-gray-700">
          {file ? file.name : t('uploadPrompt')}
        </p>
      </div>
      {originImage && (
        <div className="grid grid-cols-2 gap-8 text-center text-gray-700">
          <div>
            <div className="mb-2">{t('originalImage')}</div>
            <img src={originImage} className="shadow" alt="Original" />
          </div>
          <div>
            <div className="mb-2">{t('grayscaleImage')}</div>
            <img src={targetImage} className="shadow" alt="Grayscale" />
          </div>
        </div>
      )}
          </div>
    </div>
  )
}

export default ImageGrayscale

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      messages: (await import(`../messages/${locale}.json`)).default
    }
  }
}
